import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLine from "./components/LiftLine";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";

const Lift17 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift17"
			 className={getLiftClass(isOpen, activeLiftId === '17', state)}
			 transform="translate(1851.000000, 360.000000)"
		>
			<LiftLine x1="98" y1="39.7574508" x2="13" y2="13.1149267" color={colors[0]}/>
			<LiftLine x1="226" y1="78.1970747" x2="134" y2="51.0150796" color={colors[0]}/>

			<g className="lift-label" transform="translate(214.000000, 65.994926)">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<LiftLabelTypeSeat
				seatCount="4"
				animationPart="4"
				colors={getLiftStatusColors(state, isOpen)}
				isOpen={isOpen}
				coords="160, 45"
			/>

			<polygon
				fill={colors[2]}
				transform="translate(225.547130, 78.547130) scale(-1, 1) rotate(-205.000000) translate(-225.547130, -78.547130) "
				points="220.04713 78.5471296 231.04713 73.0471296 228.675642 78.5471296 231.04713 84.0471296"/>

			<LabelLift isOpen={isOpen} text={<tspan x="-3" y="13.5">17</tspan>} state={state}/>
		</g>
	);
};

Lift17.propTypes = {};

export default Lift17;
